export const RES_ADD_ITEM = 'RES_ADD_ITEM';
export const RES_UPDATE_QUANTITY = 'RES_UPDATE_QUANTITY';
export const RES_DELETE_ITEM = 'RES_DELETE_ITEM';
export const RES_RESTORE_EXISTING_DATA = 'RES_RESTORE_EXISTING_DATA';
export const RES_CLEAR = 'RES_CLEAR';

export function reducer(state = [], action) {
  switch (action.type) {
    case 'RES_ADD_ITEM':
      return [...state, action.payload];
    case 'RES_UPDATE_QUANTITY':
      return state.map((item, index) => {
        if (index !== action.payload.index) {
          return item
        }
        return {
          ...item,
          ...action.payload.dish
        }
      });
    case 'RES_DELETE_ITEM':
      return state.filter((item, index) => index !== action.payload);
    case 'RES_RESTORE_EXISTING_DATA':
      return action.payload;    
    case 'RES_CLEAR':
      return [];  
    default:       
      return state;
  }
}

